<template>
    <div class="section">
        <div class="columns">
            <div class="column">
                <h1 class="title has-text-centered has-text-primary">{{ user.name }}</h1>
            </div>
        </div>
        <user-side-bar></user-side-bar>
        <user-garage v-if="getActiveTab[0].id == 'garage'"></user-garage>
        <user-bids v-if="getActiveTab[0].id == 'bids'"></user-bids>
        <div class="columns">
            <div class="column" v-if="getActiveTab[0].id == 'details'">
                <div class="columns" v-if="!getLoaderStatus">
                    <user-edit :user="user"></user-edit>
                    <user-details :user="user"></user-details>
                    <user-deposit v-if="balance" :balance="balance" :user="user"></user-deposit>
                </div>
            </div>
            <div class="column" v-if="getActiveTab[0].id == 'credit'">
                <user-credit :user="user"></user-credit>
            </div>
            <div class="column" v-if="getActiveTab[0].id == 'bids'">
            </div>
            <div class="column" v-if="getActiveTab[0].id == 'logs'">
                <user-logs :user="user"></user-logs>
            </div>
            <div class="column" v-if="getActiveTab[0].id == 'balance'">
                <user-balance :user="user"></user-balance>
            </div>
            <div class="column" v-if="getActiveTab[0].id == 'client-balance'">
                <transactions-client :user="user"></transactions-client>
            </div>
            <div class="column" v-if="getActiveTab[0].id == 'multiProforma'">
                <user-multi-proforma :user="user"></user-multi-proforma>
            </div>
            <div class="column" v-if="getActiveTab[0].id == 'invoices'">
                <user-invoices :user="user"></user-invoices>
            </div>
            <div class="column" v-if="getActiveTab[0].id == 'consignees'">
                <user-consignees :user="user"></user-consignees>
            </div>
        </div>
    </div>
</template>

<script>
    import apiUsers from '../../api/apiUsers'
    import userEdit from './User/UserEdit.vue'
    import userDeposit from './User/UserDeposit.vue'
    import userTransactions from './User/UserTransactions.vue'
    import userDetails from './User/UserDetails.vue'
    import appLoader from 'vue-spinner/src/ClipLoader'
    import userSideBar from './User/UserSideBar.vue'
    import userConsignees from './../Profile/Consignees.vue'
    import userInvoices from './../Profile/InvoiceDetails.vue'
    import userMessages from './User/Tabs/UserMessages.vue'
    import userLogs from './User/Tabs/UserLogs.vue'
    import userBalance from './User/Tabs/UserBalance.vue'
    import userGarage from './User/Tabs/Garage/UserGarageTable.vue'
    import userBids from '../Bids/BidsTable.vue'
    import userCredit from './User/Tabs/UserCredit.vue'
    import UserMultiProforma from "./User/Tabs/UserMultiProforma";
    import TransactionsClient from "../Balance-Statement/TransactionsClient";

    export default {
        components: {
            TransactionsClient,
            UserMultiProforma,
            appLoader,
            userEdit,
            userDeposit,
            userTransactions,
            userDetails,
            userSideBar,
            userConsignees,
            userInvoices,
            userMessages,
            userLogs,
            userBalance,
            userGarage,
            userBids,
            userCredit
        },
        data() {
            return {
                user: '',
                success: true,
                balance: '',
                options: this.$store.getters.getOptions
            }
        },
        computed: {
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            },
            getActiveTab() {
                return this.$store.getters.getUserActiveTab
            }
        },
        created() {
            this.$store.dispatch('setStatusLoading')
            apiUsers
                .userRequest(this.$route.params.id)
                .then((response) => {
                    this.user = response.data
                    this.user.role = response.data.roles[0].name
                    this.balance = this.user.balance
                    this.$store.dispatch('setTransactions', this.user.transaction)
                    this.$store.dispatch('setSettings', this.user.settings)
                    this.$store.dispatch('setDetails', this.user.details)
                    this.$store.dispatch('setStatusLoaded')
                })
                .catch((error) => {

                })
        },
        methods: {
            isSalesStaff() {
                if (this.$store.getters.getUserRole === 'Sales Staff') {
                    return true
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/UserEdit.vue